import axios from '../index';

export const requestPatientsData = ({ id }) => axios.get(`/fhir/Patient/${id}`);

export const requestPatientUpdate = ({ id }) => axios.patch(`/redcap/update/${id}`);
